import { UpdateIcon } from "../../../images";
import { CustomButton } from "../../CustomButton";
import { AccountPlanModal } from "../../modal";
import { useState } from "react";
import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";
import { useUpdateAccountPlanGenerationMutation } from "../../../../api";
import { AccountPlanStatus } from "../../../../types/enums";
import { CircularProgress } from "@mui/material";

export const UpdateAccountsPlanBtn = ({
  campaign_id,
  hideButton = true,
  isSingleAccount,
  account_id,
  onClose,
  btnHeight = "42px",
  btnPadding = "8px",
}: {
  campaign_id: string;
  isSingleAccount?: boolean;
  account_id?: string;
  hideButton?: boolean;
  onClose?: () => void;
  btnHeight?: string;
  btnPadding?: string;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(hideButton);

  const [updateAccountPlans, { isLoading }] =
    useUpdateAccountPlanGenerationMutation();

  const handleClose = () => {
    setIsOpen(false);
    onClose && onClose();
  };

  const submitHandler = (account_ids: string[]) => {
    updateAccountPlans({
      campaign_id,
      account_ids,
    })
      .unwrap()
      .then(handleClose)
      .catch((err) => {
        toast.error(
          <CustomToast
            type={"error"}
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
            title={"Something went wrong"}
          />,
        );
      });
  };

  const updateHandler = () => {
    if (isSingleAccount && account_id) {
      submitHandler([account_id]);
    } else {
      setIsOpen(true);
    }
  };

  return (
    <>
      {!hideButton && (
        <CustomButton
          onClick={updateHandler}
          variant="outlined"
          customColor="#FFFFFF"
          textColor="#1D3E70"
          type="button"
          customSize="fit"
          style={{ padding: btnPadding }}
          sx={{
            borderColor: "#FE8836",
            minWidth: "fit-content",
            height: btnHeight,
          }}
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size={24} sx={{ color: "#1C3C6C" }} />
          ) : (
            <UpdateIcon color={"#CB6D2B"} />
          )}
        </CustomButton>
      )}

      {isOpen && (
        <AccountPlanModal
          title={"Update Account Plans"}
          description={
            "Which accounts would you like to update Account Plans for?"
          }
          status_filter={AccountPlanStatus.needs_update}
          submitBtnText={"Update Account Plans"}
          onClose={handleClose}
          isLoading={isLoading}
          onSubmit={submitHandler}
        />
      )}
    </>
  );
};
